import React, { FC } from 'react'

import { Icons } from '../../../Icon'
import { FormLabelProps } from '../../FormLabel'

import * as SC from './styled'

export type FormFieldSelectProps = React.InputHTMLAttributes<HTMLSelectElement> & {
  className?: string
  label?: string
  name: string
  value?: string
  options: { label: string; value: string }[]
  help?: string
  error?: string
  hasError?: boolean
  isBigLabel?: boolean
  labelVariant?: FormLabelProps['variant']
}

const FormFieldSelect: FC<FormFieldSelectProps> = (props) => {
  const {
    className,
    label,
    placeholder,
    options,
    help,
    error,
    hasError,
    isBigLabel = false,
    labelVariant,
    ...selectProps
  } = props

  return (
    <SC.Container className={className} $isDisabled={selectProps.disabled}>
      {label && (
        <SC.Label
          required={selectProps.required}
          error={!!error || hasError}
          $isBigLabel={isBigLabel}
          variant={labelVariant}
        >
          {label}
        </SC.Label>
      )}
      <SC.SelectContainer>
        <SC.Select $error={!!error || hasError} {...selectProps}>
          {placeholder && (
            <option value="" disabled defaultChecked>
              {placeholder}
            </option>
          )}
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </SC.Select>
        <SC.SelectArrow icon={Icons.dropdown} />
      </SC.SelectContainer>
      {!error && help && <SC.Help>{help}</SC.Help>}
      {error && <SC.Error>{error}</SC.Error>}
    </SC.Container>
  )
}

export default FormFieldSelect
